import AntSegmented from "antd/es/segmented";
import styled from "styled-components";

const Segmented = styled(AntSegmented)`
  .ant-segmented-item-label {
    padding: 3px 6px;
  }
`;

export default Segmented;
